import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";

import { CONTROL_APP_STATE } from "./config/control-app.states";
import { ControlCoreModule } from "../control-core/control-core.module";
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { RegistroComponent } from './views/registro/registro.component';
import { PeticionComponent } from './views/peticion/peticion.component';
import { ConsultaWarehouseComponent } from './views/whr/consulta/consulta-warehouse.component';
import { WhrDetalleComponent } from './views/whr/whr-detalle/whr-detalle.component';
import { OrdenpagoComponent } from './views/ordenpago/ordenpago.component';
import { DetalleordenpagoComponent } from './shared/detalleordenpago/detalle-orden-pago.component';
import { WhrCotizarComponent } from './shared/whr-cotizar/whr-cotizar.component';
import { EdicionclienteComponent } from './views/cliente/edicion-perfil/edicion-perfil.component';
import { BuscarCiudadComponent } from './shared/buscar-ciudad/buscar-ciudad.component';
import { NotificacionComponent } from './views/notificacion/notificacion.component';
import { CrearNotificacionComponent } from "./shared/crear-notificacion/crear-notificacion.component";
import { DetalleoNotificacionComponent } from "./shared/detalle-notificacion/detalle-notificacion.component";
import { DireccionesUserComponent } from "./shared/direcciones-user/direcciones-user.component";
import { DireccionUserComponent } from './shared/direccion-user/direccion-user.component';

@NgModule({
  declarations: [
    DashboardComponent,
    RegistroComponent,
    PeticionComponent,
    ConsultaWarehouseComponent,
    WhrDetalleComponent,
    OrdenpagoComponent,
    DetalleordenpagoComponent,
    CrearNotificacionComponent,
    DetalleoNotificacionComponent,
    WhrCotizarComponent,
    EdicionclienteComponent,
    BuscarCiudadComponent,
    NotificacionComponent,
    DireccionesUserComponent,
    DireccionUserComponent
  ],
  imports: [
    ControlCoreModule,
    UIRouterModule.forChild({
      states: CONTROL_APP_STATE
    })
  ],
  providers: [],
  exports: [
    ControlCoreModule,
    RegistroComponent,
    PeticionComponent,
    OrdenpagoComponent,
    DetalleordenpagoComponent,
    CrearNotificacionComponent,
    DetalleoNotificacionComponent,
    EdicionclienteComponent,
    BuscarCiudadComponent,
    NotificacionComponent,
    DireccionesUserComponent,
    DireccionUserComponent
  ]
})
export class ControlAppModule {
}




// WEBPACK FOOTER //
// ./src/app/control-app/control-app.module.ts